// Via Dependencies
import CompanyUsersTable from './CompanyUsersTable'
import UserInvitationsTable from './user-invitations/components/UserInvitationsTable'
import CompanyContactsTable from './CompanyContactsTable'
import { setActiveTab } from '../actions/companyUsers'

const CompanyUsersList = ({ companyUsersUrl, userInvitationsUrl, companyContactsUrl, activeTab, dispatch }) => (
  <div className="main-app-content">
    <div>
      <ul className="react-nav-tabs">
        <li className={activeTab === 'active' ? 'active' : undefined}>
          <Link to={companyUsersUrl} onClick={e => {
            dispatch(setActiveTab('active'))
          }}>Active</Link>
        </li>
        <li className={activeTab === 'invited' ? 'active' : undefined}>
          <Link to={userInvitationsUrl} onClick={e => {
            dispatch(setActiveTab('invited'))
          }}>Invited</Link>
        </li>
        <li className={activeTab === 'contacts' ? 'active' : undefined}>
          <Link to={companyContactsUrl} onClick={e => {
            dispatch(setActiveTab('contacts'))
          }}>Contacts</Link>
        </li>
      </ul>
    </div>
    <div id="tab-content" className="company-users-tab-content">
      <Route path={companyUsersUrl} component={CompanyUsersTable} />
      <Route path={userInvitationsUrl} component={UserInvitationsTable} />
      <Route path={companyContactsUrl} component={CompanyContactsTable} />
    </div>
  </div>
)
const mapStateToProps = ({ companyUsersUrl, userInvitationsUrl, companyContactsUrl, activeTab, hasOpenForm }) => ({
  companyUsersUrl,
  companyContactsUrl,
  userInvitationsUrl,
  activeTab,
  hasOpenForm
})
export default connect(mapStateToProps)(CompanyUsersList)



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/CompanyUsersList.js